/**
 * Avatar — initials in a tinted circle (Remote's team list). The hue is
 * derived from the name so the same person always gets the same colour.
 */
const HUES = [
  "bg-sky-100 text-sky-800",
  "bg-emerald-100 text-emerald-800",
  "bg-violet-100 text-violet-800",
  "bg-amber-100 text-amber-900",
  "bg-rose-100 text-rose-800",
  "bg-teal-100 text-teal-800",
];

export function initialsOf(name: string | null | undefined): string {
  const parts = (name ?? "").trim().split(/[\s@._-]+/).filter(Boolean);
  if (parts.length === 0) return "?";
  const first = parts[0][0] ?? "";
  const last = parts.length > 1 ? parts[parts.length - 1][0] ?? "" : "";
  return (first + (last ? "." + last : "")).toUpperCase();
}

export function Avatar({
  name,
  size = 32,
  className = "",
}: {
  name: string | null | undefined;
  size?: 24 | 28 | 32 | 36 | 40;
  className?: string;
}) {
  const key = (name ?? "").split("").reduce((a, c) => a + c.charCodeAt(0), 0);
  const hue = HUES[key % HUES.length];
  const text = size <= 28 ? "text-[10px]" : "text-xs";
  return (
    <span
      aria-hidden="true"
      style={{ width: size, height: size }}
      className={`inline-flex items-center justify-center rounded-full font-semibold shrink-0 ${hue} ${text} ${className}`}
    >
      {initialsOf(name)}
    </span>
  );
}
